import { Vector3 } from "@babylonjs/core/Maths/math.vector.js";
export class WorldTransform {
    constructor(params) {
        this._currentPosition = new Vector3();
        this._moveWorld = (newOrigin) => {
            this._guiParentNode.position = newOrigin;
            this._currentPosition = newOrigin;
        };
        this._scene = params.scene;
        this._guiParentNode = params.guiParentNode;
    }
}
